module.exports = __webpack_public_path__ + "media/images/games/k2gender/teddy-bear-9c3e3fb54e9c260f15f86fcebfdae32b.png";